<template>
    <b-overlay :show="tableLoading" rounded="sm">
        <b-card class="inner-block activity-type-list">
            <b-card-header>
                <b-row class="mt-2">
                    <b-col cols="12" class="d-flex">
                        <b-input type="text" :placeholder="$translate('search_activity_type')" v-model="filter"></b-input>
                        <slot></slot>
                    </b-col>
                </b-row>
            </b-card-header>
            <b-card-body>
                <b-col class="page-block"><strong>{{ $translate('page') }}: {{ currentPage }} {{ $translate('of') }}
                        {{ Math.ceil(rows / itemsPerPage) }} {{ $translate('total') }}:
                        {{ rows }}</strong></b-col>
                <b-col class="overflow-auto w-100 mt-4">
                    <b-table :fields="fields" responsive :items="items" :per-page="itemsPerPage"
                        :current-page="currentPage" :filter="filter">
                        <template #table-busy>
                            <div class="text-center text-danger my-2">
                                <b-spinner class="align-middle"></b-spinner>
                                <!-- <strong>{{ $translate('loading') }}</strong> -->
                            </div>
                        </template>
                        <template #cell(id)="{ item }">
                            <b-button v-if="hasPermissionView" @click="$emit('show-item', item.id)" variant="pink-button">
                                <img src="@/assets/images/icon/view.svg" />
                            </b-button>
                        </template>
                    </b-table>
                </b-col>
                <b-row>
                    <b-col>
                        <b-pagination class="justify-content-center mt-4" v-model="currentPage" :total-rows="rows"
                            :per-page="itemsPerPage" aria-controls="customerTable" :prev-text="$translate('previous')"
                            :next-text="$translate('next')" pills align="center"></b-pagination>
                    </b-col>
                </b-row>
            </b-card-body>
        </b-card>
    </b-overlay>
</template>
<script>
import popupMixins from '@/mixins/popupMixins'
import addActivityTypeIcon from '@/assets/images/icon/blue-add.svg'
import permissionsMixins from '@/mixins/permissionsMixins'

export default {
    name: 'activityTypes-ListItems',
    mixins: [popupMixins, permissionsMixins],
    props: ['type', 'title'],

    data() {
        return {
            filter: '',
            icon: addActivityTypeIcon,
            itemsPerPage: 15,
            currentPage: 1,
            tableLoading: false,
        }
    },
    mounted() {
        this.doSearch()
    },
    watch: {
        items: {
            handler: function () {
                this.tableLoading = false
            },
            deep: true,
        },
    },

    computed: {
        fields() {
            return [
                { key: 'id', label: this.$translate('actions') },
                { key: 'name', label: this.$nameLabel() },
                {
                    key: 'is_default',
                    label: this.$translate('default'),
                    formatter: value => (value ? 'Yes' : 'No'),
                },
                {
                    key: 'transaction_type',
                    label: this.$translate('transaction_type'),
                    formatter: value => (value || {}).name,
                },
                {
                    key: 'officer',
                    label: this.$translate('officer'),
                    formatter: (value) =>value && (value.first_name +' '+ value.last_name),
                },
                 {
                    key: 'interaction_type',
                    label: this.$translate('interaction_type'),
                    formatter: (value) =>value && (value.name),
                },
                {
                    key: 'activity_template',
                    label: this.$translate('activity_template'),
                    formatter: (value) =>value && (value.name),
                },
                {
                    key: 'activity_category',
                    label: this.$translate('activity_category'),
                    formatter: (value) =>value && (value.name),
                },
            ]
        },
        user() {
            return this.$store.state.user
        },

        rows() {
            return this.items.length
        },

        items() {
            const items = this.$store.state.orderType.items
            console.log('items', items)
            return items
        },
    },

    methods: {
        async doSearch() {
            this.tableLoading = true
            await this.$store.dispatch('orderType/fetchAll')
        },
    },
}
</script>
<style></style>
